import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaSearch, FaCalendarAlt, FaUser, FaSignOutAlt } from 'react-icons/fa';
import { isAuthenticated, clearAuth } from '../utils/auth';
import toast from 'react-hot-toast';

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const authenticated = isAuthenticated();

  // Hide on admin/owner routes
  if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/owner')) {
    return null;
  }

  const handleLogout = (e) => {
    e.preventDefault();
    clearAuth();
    toast.success('Logged out successfully');
    navigate('/');
    window.location.reload();
  };

  const navItems = [
    { path: '/', icon: FaHome, label: 'Home' },
    { path: '/search', icon: FaSearch, label: 'Turfs' },
    { path: '/user/bookings', icon: FaCalendarAlt, label: 'Bookings' },
    authenticated
      ? { path: '#logout', icon: FaSignOutAlt, label: 'Logout', onClick: handleLogout, isLogout: true }
      : { path: '/user/login', icon: FaUser, label: 'Profile' }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-md shadow-[0_-2px_20px_rgba(0,0,0,0.08)] border-t border-gray-100 px-6 py-3 md:hidden z-50">
      <div className="flex justify-between items-center max-w-sm mx-auto">
        {navItems.map((item) => {
          return (
            <NavLink
              key={item.label}
              to={item.path}
              onClick={item.onClick}
              className={`relative flex flex-col items-center justify-center w-16 h-14 ${item.isLogout ? 'text-red-500' : 'text-gray-400'}`}
            >
              {({ isActive: navActive }) => {
                // Force active false for logout button to avoid it staying highlighted
                const active = item.isLogout ? false : navActive;
                return (
                  <>
                    {active && (
                      <motion.div
                        layoutId="nav-pill"
                        className="absolute -top-2 w-8 h-1 bg-primary-500 rounded-full"
                        transition={{ type: "spring", stiffness: 300, damping: 30 }}
                      />
                    )}
                    <item.icon className={`text-xl mb-1 transition-colors ${active ? 'text-primary-600' : item.isLogout ? 'text-red-500' : 'text-gray-400'}`} />
                    <span className={`text-[10px] font-medium transition-colors ${active ? 'text-primary-600' : item.isLogout ? 'text-red-500' : 'text-gray-500'}`}>
                      {item.label}
                    </span>
                  </>
                )
              }}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
